import { Table, TableBody } from "@/components/ui/table";
import { CostTableHeader } from "./CostTableHeader";
import { CostTableRow } from "./CostTableRow";
import { CostTableFooter } from "./CostTableFooter";
import { CostData, CostComponent } from "@/types/project";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface CostTableProps {
  costs: CostData;
  onChange: (field: keyof CostData, updates: CostComponent) => void;
}

export function CostTable({ costs, onChange }: CostTableProps) {
  const costComponents = [
    { key: "labour" as const, label: "Labour" },
    { key: "materials" as const, label: "Materials" },
    { key: "overheads" as const, label: "Overheads" },
    { key: "plant" as const, label: "Plant" },
    { key: "staff" as const, label: "Staff" },
    { key: "subcontractor" as const, label: "Subcontractor" },
  ].sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Card className="shadow-sm border">
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Costs</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <Table>
            <CostTableHeader />
            <TableBody>
              {costComponents.map(({ key, label }) => (
                <CostTableRow
                  key={key}
                  label={label}
                  component={costs[key]}
                  onChange={(field, value) =>
                    onChange(key, { ...costs[key], [field]: value })
                  }
                  onCommentChange={(comment) =>
                    onChange(key, { ...costs[key], comment })
                  }
                />
              ))}
            </TableBody>
            <CostTableFooter costs={costs} />
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}